import { render, staticRenderFns } from "./ManuscriptSettingsDialog.vue?vue&type=template&id=3d7f2f22&scoped=true"
import script from "./ManuscriptSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptSettingsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptSettingsDialog.vue?vue&type=style&index=0&id=3d7f2f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7f2f22",
  null
  
)

export default component.exports